/**
 * 站点身份 —— 单一事实来源。
 *
 * 站名散在顶栏、i18n、`<title>` 三处就会各自漂移：本次改名（随便弹 → 漫漫弹）
 * 就正好是这三处，靠 grep 找齐的。以后改站名只改这里。
 *
 * 唯一的例外是 `index.html` 的 `<title>`：那是静态 HTML，构建前就要写死，
 * 取不到这个模块。改站名时记得同步它（顶部注释里也标了一句）。
 */
export const BRAND_NAME = '漫漫弹'

/**
 * 匾额题字 —— 首页 hero 的 h1，宋体骨架之外唯一的大字。
 *
 * 用的是设计稿原本的题字。与 `BRAND_NAME` 分工不同 ——
 * 站名是「这是什么站」，匾额是「为什么来这儿」，所以首页大标题不写站名。
 *
 * ⚠️ 这四个字走 `t.fonts.brush`（毛笔体），而毛笔体是**手写死字符集**的子集字体：
 *    改这几个字必须同步 `scripts/subset-fonts.mjs` 的 `BRUSH_CHARSET` 并重跑脚本，
 *    否则会掉回系统宋体 —— 一个标题里两种字体，很显眼。
 *
 * ⚠️ 别写「己」——站酷小薇体把它画得和「巳」几乎一模一样，匾额里会读成错字。
 *    详见 `scripts/subset-fonts.mjs` 的 `BRUSH_CHARSET` 注释。
 */
export const BRAND_TAGLINE = '江南琴案'

/**
 * 印章用字 —— 单字。
 *
 * 顶栏与登录页的方章取这一个字，不用全名：印章在传统里本就是二三字的方寸之物，
 * 30px 的方块里竖排三个字只会挤成一团。
 *
 * 首页例外：那里照设计稿用的是**竖排全名**（`.seal` 写站名），见 `HomePage.seal`。
 */
export const BRAND_SEAL = '弹'
